/* ZeroBra custom theme JS.

   Mobile product zoom modal -> lightbox.
   Dawn's zoom modal shows ONE photo, vertically centred. Product photos are
   square, a phone is tall, so ~230px of empty space sits above and below it.
   Instead of stacking the gallery (which made it look like two images opened),
   we keep one photo, put the other photos in a tappable thumbnail strip at the
   bottom, and darken the backdrop so the leftover space reads as a deliberate
   lightbox field. Mobile only; desktop keeps Dawn's stacked gallery.

   Built off a MutationObserver on the modal's `open` attribute, NOT off the
   click on .product__media-toggle. An earlier version hooked the click in the
   capture phase and assumed the modal would be open two rAFs later; that held
   in headless Chromium but not on a real iPhone, where the strip never
   appeared. Watching `open` is timing independent and also covers keyboard and
   programmatic opens.

   Thumbnails come from the GALLERY's toggles when possible: the modal contains
   every media on the product (18 on some styles) while the gallery only shows
   the selected variant's (12), so building from the modal alone would surface
   other colourways. If the gallery lookup comes up short we fall back to the
   modal's own children rather than silently rendering no strip. */
(function () {
  var MOBILE = 749;
  var OPEN_CLASS = 'zb-zoom-open';

  function srcOf(img) {
    if (!img) return null;
    return img.currentSrc || img.src || img.getAttribute('src') || null;
  }

  function fromGallery() {
    var out = [];
    var seen = {};
    var toggles = document.querySelectorAll('.product__media-toggle[data-media-id]');
    Array.prototype.forEach.call(toggles, function (toggle) {
      var id = toggle.getAttribute('data-media-id');
      if (!id || seen[id]) return;
      var item = toggle.closest('.product__media-item') || toggle.parentNode;
      if (item && getComputedStyle(item).display === 'none') return;
      var src = srcOf(item && item.querySelector('img'));
      if (!src) return;
      seen[id] = 1;
      out.push({ id: id, src: src });
    });
    return out;
  }

  function fromModal(content) {
    var out = [];
    var seen = {};
    Array.prototype.forEach.call(content.children, function (el) {
      var id = el.getAttribute && el.getAttribute('data-media-id');
      if (!id || seen[id]) return;
      if (el.classList.contains('product__media-item--variant')) return;
      var src = srcOf(el.tagName === 'IMG' ? el : el.querySelector('img'));
      if (!src) return;
      seen[id] = 1;
      out.push({ id: id, src: src });
    });
    return out;
  }

  function build(modal) {
    var dialog = modal.querySelector('.product-media-modal__dialog');
    var content = modal.querySelector('.product-media-modal__content');
    if (!dialog || !content) return;

    Array.prototype.forEach.call(
      dialog.querySelectorAll('.zb-modal-thumbs, .zb-modal-nav'),
      function (el) {
        el.parentNode.removeChild(el);
      }
    );

    var media = fromGallery();
    if (media.length < 2) media = fromModal(content);
    if (media.length < 2) return;

    // The crossfade has nothing to fade to if the next photo is still lazy.
    Array.prototype.forEach.call(content.querySelectorAll('img[loading]'), function (img) {
      img.loading = 'eager';
    });

    var strip = document.createElement('div');
    strip.className = 'zb-modal-thumbs';
    var index = 0;

    // Wraps at both ends, so neither arrow is ever a dead control.
    function go(i) {
      index = ((i % media.length) + media.length) % media.length;
      var id = media[index].id;
      media.forEach(function (m) {
        var el = content.querySelector('[data-media-id="' + m.id + '"]');
        if (el) el.classList.toggle('active', m.id === id);
      });
      Array.prototype.forEach.call(strip.children, function (btn) {
        var on = btn.getAttribute('data-media-id') === id;
        btn.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && btn.scrollIntoView) {
          btn.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      });
      content.scrollTop = 0;
    }
    content.zbGo = go;
    content.zbIndex = function () {
      return index;
    };

    media.forEach(function (m, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zb-modal-thumbs__btn';
      btn.setAttribute('data-media-id', m.id);
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      var img = document.createElement('img');
      img.src = m.src;
      img.alt = '';
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        go(i);
      });
      strip.appendChild(btn);
    });

    dialog.appendChild(strip);
    dialog.appendChild(arrow('prev', -1, go));
    dialog.appendChild(arrow('next', 1, go));
    bindSwipe(content);

    var active = content.querySelector('[data-media-id].active');
    var start = 0;
    if (active) {
      var id = active.getAttribute('data-media-id');
      media.forEach(function (m, i) {
        if (m.id === id) start = i;
      });
    }
    go(start);
  }

  function chevron(dir) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' +
      (dir === 'prev' ? 'M15 4 L7 12 L15 20' : 'M9 4 L17 12 L9 20') +
      '" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" ' +
      'stroke-linejoin="round"/></svg>'
    );
  }

  function arrow(dir, step, go) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zb-modal-nav zb-modal-nav--' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
    btn.innerHTML = chevron(dir);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      go(currentIndex(btn) + step);
    });
    return btn;
  }

  function currentIndex(el) {
    var content = el
      .closest('.product-media-modal__dialog')
      .querySelector('.product-media-modal__content');
    return content.zbIndex ? content.zbIndex() : 0;
  }

  /* Swipe. Bound once per modal; the handlers call whatever go() the latest
     build() installed, so they never hold a stale media list. Single finger
     only, and skipped while the customer is pinch-zoomed in so panning a
     zoomed photo does not jump to the next one. */
  function bindSwipe(content) {
    if (content.zbSwipeBound) return;
    content.zbSwipeBound = true;
    var x = 0;
    var y = 0;
    var live = false;

    content.addEventListener(
      'touchstart',
      function (e) {
        var vv = window.visualViewport;
        if (e.touches.length !== 1 || (vv && vv.scale > 1.05)) {
          live = false;
          return;
        }
        live = true;
        x = e.touches[0].clientX;
        y = e.touches[0].clientY;
      },
      { passive: true }
    );
    content.addEventListener(
      'touchmove',
      function (e) {
        if (e.touches.length > 1) live = false;
      },
      { passive: true }
    );
    content.addEventListener(
      'touchend',
      function (e) {
        if (!live) return;
        live = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - x;
        var dy = t.clientY - y;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        if (content.zbGo) content.zbGo(content.zbIndex() + (dx < 0 ? 1 : -1));
      },
      { passive: true }
    );
  }

  function onOpen(modal) {
    var open = modal.hasAttribute('open');
    document.documentElement.classList.toggle(OPEN_CLASS, open);
    if (!open || window.innerWidth > MOBILE) return;
    // Retry: on a real device the gallery images the thumbs are cloned from
    // may not have resolved a src on the first frame.
    [0, 120, 400].forEach(function (delay) {
      setTimeout(function () {
        if (!modal.hasAttribute('open')) return;
        if (modal.querySelector('.zb-modal-thumbs')) return;
        try {
          build(modal);
        } catch (e) {
          /* never let this break the zoom itself */
        }
      }, delay);
    });
  }

  function attach(modal) {
    if (modal.zbThumbsWatched) return;
    modal.zbThumbsWatched = true;
    new MutationObserver(function () {
      onOpen(modal);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    if (modal.hasAttribute('open')) onOpen(modal);
  }

  /* ---- Product page gallery arrows ----
     The gallery already swipes on its own: Dawn renders it as a native
     scroll-snap slider (`slider--mobile`, overflow-x:auto), so touch swiping
     was never missing. What was missing is visible arrows — Dawn only draws
     tiny ones underneath the photo next to the "1 / 6" counter. These overlay
     the photo, match the lightbox arrows, and wrap at both ends. Scrolling the
     list is all they do, so Dawn's own scroll listener keeps the counter and
     the active-slide state correct. */
  function galleryArrows() {
    if (window.innerWidth > MOBILE) return;
    var list = document.querySelector('.product__media-list');
    if (!list || list.zbNav) return;
    var host = list.closest('slider-component') || list.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    list.zbNav = true;

    function slides() {
      return Array.prototype.filter.call(list.children, function (el) {
        return getComputedStyle(el).display !== 'none';
      });
    }

    function step(dir) {
      var vis = slides();
      if (vis.length < 2) return;
      var base = vis[0].offsetLeft;
      var pos = vis.map(function (el) {
        return el.offsetLeft - base;
      });
      var cur = 0;
      var best = Infinity;
      pos.forEach(function (x, i) {
        var d = Math.abs(x - list.scrollLeft);
        if (d < best) {
          best = d;
          cur = i;
        }
      });
      var n = (((cur + dir) % pos.length) + pos.length) % pos.length;
      list.scrollTo({ left: pos[n], behavior: 'smooth' });
    }

    function make(dir, delta) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zb-gallery-nav zb-gallery-nav--' + dir;
      btn.setAttribute(
        'aria-label',
        dir === 'prev' ? 'Previous image' : 'Next image'
      );
      btn.innerHTML = chevron(dir);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        step(delta);
      });
      host.appendChild(btn);
      return btn;
    }

    var prev = make('prev', -1);
    var next = make('next', 1);

    // Pin them to the photo's real edges. Two reasons this can't be pure CSS:
    // the slider-component also contains the counter row underneath, so 50%
    // is not the photo's vertical centre; and the gallery is a `grid--peek`
    // layout, so the photo is not horizontally centred in its container
    // either (the next slide peeks in on the right). Slide width and snap
    // position are constant, so adding scrollLeft back gives the photo box as
    // it sits when snapped, whatever slide is showing.
    function place() {
      var vis = slides();
      var hide = vis.length < 2;
      prev.style.display = hide ? 'none' : '';
      next.style.display = hide ? 'none' : '';
      if (hide) return;
      var lr = list.getBoundingClientRect();
      var hr = host.getBoundingClientRect();
      var s0 = vis[0].getBoundingClientRect();
      if (!lr.height || !s0.width) return;
      var top = lr.top - hr.top + lr.height / 2 + 'px';
      var left = s0.left + list.scrollLeft - hr.left;
      prev.style.top = top;
      next.style.top = top;
      prev.style.left = left + 8 + 'px';
      next.style.left = left + s0.width - 8 - next.offsetWidth + 'px';
      next.style.right = 'auto';
    }
    place();
    if (window.ResizeObserver) new ResizeObserver(place).observe(list);
    window.addEventListener('resize', place);
  }

  function scan() {
    Array.prototype.forEach.call(
      document.querySelectorAll('product-modal'),
      attach
    );
    galleryArrows();
  }

  scan();
  // Sections can re-render (variant change, theme editor), so keep looking.
  // Debounced: this page has apps that mutate the DOM constantly.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      scan();
    }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
